import type { Placement } from '../types';

export const placementConfig: Record<Placement, string[]> = {
    'recently-viewed': [
        'en-us',
        'es-us',
        'da-dk',
        'de-at',
        'de-ch',
        'de-de',
        'en-gb',
        'en-ie',
        'es-es',
        'fi-fi',
        'fr-be',
        'fr-ch',
        'fr-fr',
        'it-ch',
        'it-it',
        'nb-no',
        'nl-be',
        'nl-nl',
        'pt-pt',
        'sv-se',
    ],
};
